<template>
	<div class="goods">
		<v-head :title="title"></v-head>
<van-cell-group>
  <van-field
    v-model.trim="oldPassword" 
    type="password"
    label="旧密码"
    placeholder="请您输入您的原密码"
    required
  />
    <van-field
    v-model.trim="newPassword"
    type="password"
    label="新密码"
    placeholder="请您输入您的原密码"
    required
  />
    <van-field
    v-model.trim="newPasswordTwo" 
    type="password"
    label="确认密码"
    placeholder="请您输入您的原密码"
    required
  />
</van-cell-group>
      <p class="warm">
          <template v-if="warmTxt">
            {{warmTxt}}
          </template>
        </p>
<div class="nextBtn">
 <van-button  type="primary" @click="savePD">保 存</van-button>
</div>
	</div>
</template>
<script>
import {
  passwordSubmit,
} from "@/api/login";
import { Field, Button,Toast,CellGroup } from "vant";
import vHead from "../../components/Subhead.vue";
import { getSessionStore } from "@/utils/sessionStorage";
export default {
  data() {
    return {
     title:"修改密码",
      oldPassword: "",
      newPassword: "",
      newPasswordTwo: "",
       warmTxt: "",
    };
  },
  components: {
    vHead,
    [Field.name]: Field,
    [Button.name]: Button,
    [Toast.name]: Toast,
    [CellGroup.name]: CellGroup,
  },
  methods: {

       savePD() {
      let token = getSessionStore("access_token");
      let oldPassword = this.oldPassword,
        newPassword = this.newPassword,
        newPasswordTwo = this.newPasswordTwo,
        isChecked = this.$regexp.password(newPassword),
        regexpPassword = this.$regexp.chinese(newPassword),
        params = {
          oldPassword,
          newPassword,
          access_token:token
        };

      if (!oldPassword) {
        Toast("请输入旧密码");
        return false;
      } else if (!newPassword) {
        Toast("请输入新密码");
        return false;
      } else if (!isChecked || regexpPassword) {
          Toast("密码必须为8-16为包含字母、数字、符号中至少2种且不能有空格");
        return false;
      } else if (newPasswordTwo !== newPassword) {
      	 Toast("两次新密码不一致");
        return false;
      } else {
       
      }

      passwordSubmit(params)
        .then(res => {
          if (res.success) {
            Toast.success("修改密码成功");
             this.$router.push({ name: 'MemberCenter'});
          } else {
            Toast("用户信息获取失败");
          }
        })
        .catch(res => {
          Toast("您输入的旧密码不正确");
        });
    },
  }
};
</script>

<style scoped>
body{ background:#fafafa; }
/deep/.van-nav-bar .van-icon{
  color: #fff;
}
.nextBtn{ padding: 0 20px; margin-top: 25px; text-align: center; }
/deep/.van-cell-group{ padding: 0 20px;border-top: #fff solid 15px; }
/deep/.van-button--normal{ width: 100%; }
/deep/.van-field__label{ width: 2.4rem;  color: #666; font-size:14px;}
/deep/.van-cell--required{padding-top:15px; padding-bottom: 15px;}
/deep/.van-cell{ border-bottom: #ededed solid 1px; }
</style>